import { watchEffect } from 'vue';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import { DateFormat } from '@/types/dates';
import { useI18n } from 'vue-i18n';

export const useDate = () => {
  const { locale } = useI18n();

  watchEffect(() => {
    dayjs.locale(locale.value);
  });

  const formatDate = (
    date: dayjs.ConfigType,
    format: DateFormat,
  ) => dayjs(date).locale(locale.value).format(format);

  const setLocale = (newLocale: string) => {
    locale.value = newLocale;
    dayjs.locale(newLocale);
  };

  const isDatePassed = (date: string | Date | Dayjs): boolean => {
    const currentDate = dayjs();
    const targetDate = dayjs(date);
    return targetDate < currentDate;
  };

  const hasDifferentDate = (firstDate: string, secondDate: string) => dayjs(firstDate).date() !== dayjs(secondDate).date();

  return {
    dayjs,
    setLocale,
    formatDate,
    isDatePassed,
    hasDifferentDate,
  };
};
